import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { Grid, Select, Tooltip, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import * as moment from "moment";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import mentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import CohortSummaryModal2 from "../../../../common/cohortSummaryModal2";
import { MY_MENTORS_LIST } from "../../../../common/constants/ApplicationUrl";
import axios from "axios";
import "./style.scss";
import { useWindowDimensions } from "../../../../common/windowsize";
import api from "../../../../common/dependencies/utils/Api";

const useStyles = makeStyles((theme) => ({
  table: {
    [theme.breakpoints.down("md")]: {
      overflowX: "hidden",
    },
  },
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    // whiteSpace: "nowrap",
  },

  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "right",
      textAlign: "right",
      position: "relative",
      paddingLeft: "100px",
      fontSize: "13px",
    },
  },
  tableHeader: {
    fontSize: "14px",
    fontFamily: "Montserrat",
    // color: "#816aaf",
    color: "#212529",
    fontWeight: 600,
    padding: "7px 5px",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      left: "16px",
      top: "16px",
      width: "170px",
      textAlign: "left",
      fontSize: "12px",
    },
  },
  root: {
    marginBottom: "30px",
    [theme.breakpoints.down("md")]: {
      overflowX: "scroll",
    },
  },
  commonWidth: {
    width: "205px",
  },
  lessWidth: {
    width: "170px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    "&:hover": {
      cursor: "pointer",
    },
  },
  tooltip: {
    backgroundColor: "#816aaf",
    // backgroundColor: '#efefef'
  },
  tooltipTy: {
    color: "#fff",
    fontFamily: "Montserrat",
    fontSize: "16px",
  },
}));

const data = [
  {
    logo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29ufGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    name: "Startup Name a",
    mentors: 5,
    mentorships: 3,
    scheduled: 7,
    completed: 10,
    hours: 4,
    hoursCompleted: 24,
  },
  {
    logo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29ufGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    name: "Startup Name a",
    mentors: 5,
    mentorships: 3,
    scheduled: 7,
    completed: 10,
    hours: 4,
    hoursCompleted: 24,
  },
  {
    logo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29ufGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    name: "Startup Name a",
    mentors: 5,
    mentorships: 3,
    scheduled: 7,
    completed: 10,
    hours: 4,
    hoursCompleted: 24,
  },
];

export default function BasicTable(props) {
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const classes = useStyles();
  // const { data } = props;
  const [modalVisibility, setModalVisibility] = React.useState(false);
  const [fromModule, setFromModule] = React.useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [cohortModalData, setCohortModalData] = React.useState("");
  // React.useEffect(() => {
  //   const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  //   props.openLoader();

  // }, []);
  const getMentorsList = (id) => {
    let params = {
      requestedBy: id,
    };

    // axios({
    //   url: MY_MENTORS_LIST,
    //   method: "POST",
    //   data: {
    //     requestedBy: id,
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORS_LIST, {
        requestedBy: id,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        setCohortModalData(res?.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  const dimension = useWindowDimensions();
  const small = dimension.width < 900;

  const HeaderItem = (props) => {
    return small ? <div className={classes.tableHeader}>{props.t}</div> : "";
  };
  return (
    <div className="messagetable-mom">
      <Box className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            {!small && props.data?.length > 0 && (
              <TableHead>
                <TableRow>
                  <TableCell
                    className={[
                      clsx(
                        classes.tableRightBorder,
                        classes.tableHeader,
                        "tableJustify fixColumbnWidth4"
                      ),
                    ]}
                  >
                    NO.
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    STARTUP
                  </TableCell>

                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    TOTAL MENTORS
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    TOTAL MENTORSHIPS
                  </TableCell>
                  {/* <TableCell
                  className={clsx(
                    classes.tableRightBorder,
                    classes.tableHeader
                  )}
                >
                  VIEW MENTORSHIPS
                </TableCell> */}
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    SESSIONS 
                  </TableCell>
                  {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    SESSIONS COMPLETED
                  </TableCell> */}
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    HOURS 
                  </TableCell>
                  {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                  >
                    HOURS COMPLETED
                  </TableCell> */}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {props.data?.length > 0 ? (
                props.data?.map((datum, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor:
                        props.selectedRow == index ? "#e2d2ed" : "",
                    }}
                  >
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="NO." />
                      {(props.currentPage - 1) * 10 + index + 1}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="STARTUP" />
                      {/* <Tooltip
                      classes={{
                        tooltip: classes.tooltip,
                        tooltipArrow: classes.tooltipArrow,
                      }}
                      PopperProps={{
                        disablePortal: true,
                      }}
                      arrow
                      title={
                        <Typography
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#fff",
                            fontWeight: "bold",
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          View Profile
                        </Typography>
                      }
                    > */}
                      <div className="newuserTooltip">
                        <Link
                          style={{
                            color: "#3ac2d7",
                            textDecoration: "underline",
                          }}
                        >
                          <img
                            src={datum.startupLogoPath || hashImage}
                            style={{
                              height: "100px",
                              width: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              redirectProfile(datum.dpiitNumber);
                            }}
                            // onClick={() => {
                            //   let sample;
                            //   const currentRoute = window.location.href;
                            //   sample = currentRoute.slice(
                            //     0,
                            //     currentRoute.lastIndexOf("/")
                            //   );
                            //   let reRoute = window.open(
                            //     sample + "/startup-profile",
                            //     "_blank"
                            //   );
                            //   reRoute.id = datum.dpiitNumber;
                            // }}
                          />
                        </Link>
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            left: "50px",
                            top: "88px",
                            width: "150px",
                            padding: "3px 10px",
                          }}
                        >
                          View Startup Profile
                        </span>
                      </div>
                      {/* </Tooltip> */}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      {/* <Tooltip
                      classes={{
                        tooltip: classes.tooltip,
                        tooltipArrow: classes.tooltipArrow,
                      }}
                      PopperProps={{
                        disablePortal: true,
                      }}
                      arrow
                      title={
                        <Typography
                          style={{
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#fff",
                            fontWeight: "bold",
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          View Profile
                        </Typography>
                      }
                    > */}
                      <div
                        style={{
                          flexDirection: "column",
                          display: "flex",
                          justifyContent: "space-between",

                          // maxWidth: "240px",
                        }}
                      >
                        <div
                          style={{
                            cursor: "default",
                            alignItems: "center",
                            display: "flex",
                            maxWidth: "240px",
                          }}
                        >
                          {datum.startupName}
                        </div>
                        <div
                          className="newuserTooltip"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <div
                            className="d-flex justify-content-end "
                            style={{
                              cursor: "pointer",

                              alignItems: "end",
                              justifyContent: "center",
                              height: "100px",
                              width: "40px",
                              display: "flex",
                            }}
                          >
                            <img
                              src={profile}
                              onClick={() => {
                                redirectProfile(datum.dpiitNumber);
                              }}
                              //  onClick={() => {
                              //   let sample;
                              //   const currentRoute = window.location.href;
                              //   sample = currentRoute.slice(
                              //     0,
                              //     currentRoute.lastIndexOf("/")
                              //   );
                              //   let reRoute = window.open(
                              //     sample + "/startup-profile",
                              //     "_blank"
                              //   );
                              //   reRoute.id = datum.dpiitNumber;
                              // }}
                            />
                          </div>
                          <span
                            className="tooltiptext2 tooltip-bottom2"
                            style={{
                              left: "-19px",
                              top: "106px",
                              width: "150px",
                              padding: "3px 10px",
                            }}
                          >
                            View Startup Profile
                          </span>
                        </div>
                      </div>
                      {/* </Tooltip> */}
                    </TableCell>
                    {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                    {datum.totalMentors}
                    
                  </TableCell> */}
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="TOTAL MENTORS" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div> {datum.totalMentors}</div>
                        <div
                          className="d-flex justify-content-end newuserTooltip"
                          style={{
                            cursor: "pointer",
                            alignItems: "end",
                            justifyContent: "center",
                            height: "100px",
                            width: "40px",
                            display: "flex",
                          }}
                          onClick={() => {
                            //
                            setModalVisibility(true);
                            setFromModule("Mentor");
                            // getMentorsList(datum.startupId)
                            setCohortModalData(datum.startupId);
                          }}
                        >
                          <img
                            onClick={() => {
                              // // let reRoute = window.open(
                              // //   `/dashboard/mentorship/${datum.startupId}`,
                              // //   "_blank"
                              // // );
                              // // let reRoute = window;
                              // reRoute.startupData = datum;
                              // reRoute.my_special_setting = "Hello World";
                            }}
                            src={mentorIcon}
                            alt={datum.title}
                          />
                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              top: "100px",
                              left: "30px",
                              padding: "3px 10px",
                            }}
                          >
                            View Mentors List
                          </span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="TOTAL MENTORSHIPS" />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div> {datum.totalMentorships}</div>
                        <div
                          className="d-flex justify-content-end newuserTooltip"
                          style={{
                            cursor: "pointer",
                            alignItems: "end",
                            justifyContent: "center",
                            height: "100px",
                            width: "40px",
                            display: "flex",
                          }}
                        >
                          <img
                            onClick={() => {
                              let reRoute = window.open(
                                `/dashboard/mentorship/${datum.startupId}`,
                                "_blank"
                              );
                              // let reRoute = window;
                              reRoute.startupData = datum;
                              reRoute.my_special_setting = "Hello World";
                            }}
                            src={mentorshipIcon}
                            alt={datum.title}
                          />
                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              top: "100px",
                              left: "30px",
                              padding: "3px 10px",
                            }}
                          >
                            View Mentorships
                          </span>
                        </div>
                      </div>
                    </TableCell>
                    {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableFont
                    )}
                  >
                   
                    <div className="newuserTooltip">
                      <Link
                        style={{
                          cursor: "pointer",
                          color: "#277acc",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          

                          let reRoute = window.open(
                            `/dashboard/mentorship/${datum.startupId}`,
                            "_blank"
                          );
                          // let reRoute = window;
                          reRoute.startupData = datum;
                          reRoute.my_special_setting = "Hello World";
                        }}
                      >
                        View
                      </Link>
                      <span className="tooltiptext tooltip-bottom">
                        View Mentorship
                      </span>
                    </div>
                  </TableCell> */}
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}>
                      <HeaderItem t="SESSIONS" />
                      Scheduled : {datum.sessionScheduled}<br></br>
                      Compeleted : {datum.sessionCompleted}
                    </TableCell>
                    {/* <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="SESSIONS " />
                      {datum.sessionCompleted}
                    </TableCell> */}
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="HOURS SCHEDULED" />
                      Scheduled : {datum.hoursScheduled}<br></br>
                      Compeleted : {datum.hoursCompleted}
                    </TableCell>
                    {/* <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont
                      )}
                    >
                      <HeaderItem t="HOURS COMPLETED" />
                      {datum.hoursCompleted}
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <tr colSpan={8} style={{ border: "none" }}>
                  <td
                    className="d-flex justify-content-center desknorecords"
                    style={{ border: "none" }}
                  >
                    {" "}
                    <div
                      className="no-records"
                      style={{
                        position: "relative",
                        // left: "28rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      No Records Found
                    </div>
                  </td>
                  <td
                    className="d-flex justify-content-center mobilenorecords"
                    style={{ border: "none" }}
                  >
                    {" "}
                    <div
                      className="no-records"
                      style={{
                        position: "relative",
                        // left: "28rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      No Records Found
                    </div>
                  </td>
                </tr>
              )}
            </TableBody>
            <CohortSummaryModal2
              setModalVisibility={setModalVisibility}
              fromModule={fromModule}
              modalVisibility={modalVisibility}
              mentorShipId={cohortModalData}
              fromPage={"mentorships"}
            />
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
